import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import NguonVonApi from "service/nguonVonApi";
import { formatNumber } from "utils/currencyFormat";
import { LichSuGiaoDich } from "./LichSuGiaoDich";
export const ModalChiTiet = (props) => {
  const dataInit = {
    Ten: "",
    DiaChi: "",
    NgaySinh: "",
    SoDienThoai: "",
    CMND: "",
    NgayCap: "",
    NoiCap: "",
  };
  const [dataChiTiet, setDataChiTiet] = useState(dataInit);
  useEffect(() => {
    NguonVonApi.chiTietNguonVon(props.customerId).then((response) => {
      setDataChiTiet({
        ...dataChiTiet,
        Ten: response.data.Ten,
        DiaChi: response.data.DiaChi,
        NgaySinh: response.data.NgaySinh,
        SoDienThoai: response.data.SoDienThoai,
        CMND: response.data.CMND,
        NgayCap: response.data.NgayCap,
        NoiCap: response.data.NoiCap,
      });
    });
  }, []);
  return (
    <Modal
      {...props}
      size="modal-xl modal-xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title  color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-bookmark-multiple-outline"></i>
          </span>{" "}
          Chi tiết
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse253"
                className="card-header"
                href="#collapse253"
                aria-expanded="true"
                aria-controls="collapse253"
              >
                <a
                  href={() => false}
                  className="card-title lead info collapsed"
                >
                  <h3>Chi tiết giao dịch</h3>
                </a>
              </div>
              <div className="card-collapse collapse show">
                <div className="card-content">
                  <div className="card-body">
                    <div class="from-thongtintra">
                      <p>
                        <div className="row">
                          <div className="col-2 color7-bold">Mã cổ đông</div>
                          <div className="col-3 text-left  text-normal color7">
                            {props.item.Code}
                          </div>
                        </div>
                      </p>

                      <p>
                        <div className="row">
                          <div className="col-2 color7-bold">Cổ đông</div>
                          <div className="col-3 text-left  text-normal color7">
                            {dataChiTiet.Ten}
                          </div>
                        </div>
                      </p>

                      <p>
                        <div className="row">
                          <div className="col-2 color7-bold">Số điện thoại</div>
                          <div className="col-3 text-left  text-normal color7">
                            {dataChiTiet.SoDienThoai}
                          </div>
                        </div>
                      </p>

                      <p>
                        <div className="row">
                          <div className="col-2 color7-bold">Số tiền vốn</div>
                          <div className="col-3 text-left  text-normal color7">
                            <span className="color-do-bold">
                              {formatNumber(props.item.GiaTri)}{" "}
                              <span className="black-price">(vnđ)</span>
                            </span>
                          </div>
                        </div>
                      </p>
                      <p>
                        <div className="row">
                          <div className="col-2 color7-bold">Tỉ lệ vốn</div>
                          <div className="col-3 text-left  text-normal color7">
                            {props.item.TiLe} %
                          </div>
                        </div>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <LichSuGiaoDich item={props.item} customerId={props.customerId} />
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer">
        <button
          type="button"
          class="btn btn-new-main btn-closenew"
          href={() => false}
          onClick={props.onHide}
        >
          <span>
            <i class="mdi mdi-close"></i>
          </span>
          &nbsp; Đóng &nbsp;
        </button>
      </Modal.Footer>
    </Modal>
  );
};
